import { useEffect, useState } from "react";
import { findCurrentVolume } from "../utils/volumeWindow";
// an empty volumeId makes the backend create the volume running today from the title's anchor
export var CURRENT_VOLUME_TO_CREATE = "";
export var useIssueVolumeChoice = function (open, volumes) {
    var _a, _b;
    var _c = useState(null), chosenVolumeId = _c[0], setChosenVolumeId = _c[1];
    useEffect(function () {
        if (!open) {
            setChosenVolumeId(null);
        }
    }, [open]);
    var volumeId = (_b = chosenVolumeId !== null && chosenVolumeId !== void 0 ? chosenVolumeId : (_a = findCurrentVolume(volumes)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : CURRENT_VOLUME_TO_CREATE;
    return {
        volumeId: volumeId,
        setVolumeId: setChosenVolumeId,
        requestVolumeId: volumeId === CURRENT_VOLUME_TO_CREATE ? undefined : volumeId,
    };
};
